import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiService } from '../../../services/api.service';
import { ParkingSession } from '../../../models/parking-mall.model';

@Component({
  selector: 'app-sessions-list',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatTabsModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './sessions-list.component.html',
  styleUrl: './sessions-list.component.scss'
})
export class SessionsListComponent implements OnInit {
  activeSessions: ParkingSession[] = [];
  sessionHistory: ParkingSession[] = [];
  loading = true;
  displayedColumns: string[] = ['mallId', 'carId', 'startTime', 'duration', 'paymentType', 'cost', 'status', 'actions'];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadActiveSessions();
  }

  loadActiveSessions(): void {
    this.loading = true;
    
    // Демо дані для активних сесій
    this.activeSessions = [
      {
        _id: '1',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-1',
        carNumber: 'AA 1234 BB',
        startTime: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 години тому
        cost: 40,
        status: 'active',
        paymentType: 'hourly'
      },
      {
        _id: '2',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-2',
        carNumber: 'KA 5678 XX',
        startTime: new Date(Date.now() - 45 * 60 * 1000), // 45 хвилин тому
        cost: 15,
        status: 'active',
        paymentType: 'subscription',
        subscriptionName: 'Місячний абонемент'
      },
      {
        _id: '3',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-3',
        carNumber: 'AI 9876 CM',
        startTime: new Date(Date.now() - 4 * 60 * 60 * 1000), // 4 години тому
        cost: 80,
        status: 'active',
        paymentType: 'hourly'
      },
      {
        _id: '4',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-4',
        carNumber: 'BC 2468 KK',
        startTime: new Date(Date.now() - 30 * 60 * 1000), // 30 хвилин тому
        cost: 0,
        status: 'active',
        paymentType: 'subscription',
        subscriptionName: 'VIP абонемент'
      },
      {
        _id: '5',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-5',
        carNumber: 'AO 1357 OI',
        startTime: new Date(Date.now() - 90 * 60 * 1000), // 1.5 години тому
        cost: 30,
        status: 'active',
        paymentType: 'hourly'
      }
    ];

    this.loading = false;
  }

  loadHistory(): void {
    this.loading = true;
    
    // Демо дані для історії сесій
    this.sessionHistory = [
      {
        _id: '101',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-1',
        carNumber: 'AA 1234 BB',
        startTime: new Date(Date.now() - 24 * 60 * 60 * 1000), // вчора
        endTime: new Date(Date.now() - 22 * 60 * 60 * 1000), // 2 години
        cost: 60,
        status: 'completed',
        paymentType: 'hourly'
      },
      {
        _id: '102',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-2',
        carNumber: 'KA 5678 XX',
        startTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
        endTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000 + 3 * 60 * 60 * 1000),
        cost: 0,
        status: 'completed',
        paymentType: 'subscription',
        subscriptionName: 'Місячний абонемент'
      },
      {
        _id: '103',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-3',
        carNumber: 'AI 9876 CM',
        startTime: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
        endTime: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 5 * 60 * 60 * 1000),
        cost: 150,
        status: 'completed',
        paymentType: 'hourly'
      },
      {
        _id: '104',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-4',
        carNumber: 'BC 2468 KK',
        startTime: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000),
        endTime: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000 + 1 * 60 * 60 * 1000),
        cost: 0,
        status: 'completed',
        paymentType: 'subscription',
        subscriptionName: 'VIP абонемент'
      },
      {
        _id: '105',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-5',
        carNumber: 'AO 1357 OI',
        startTime: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
        endTime: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000 + 45 * 60 * 1000),
        cost: 25,
        status: 'completed',
        paymentType: 'hourly'
      },
      {
        _id: '106',
        mallId: 'ocean-plaza',
        mallName: 'Ocean Plaza',
        carId: 'user-car-1',
        carNumber: 'AA 1234 BB',
        startTime: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
        endTime: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000 + 20 * 60 * 1000),
        cost: 10,
        status: 'cancelled',
        paymentType: 'hourly'
      }
    ];

    this.loading = false;
  }

  getDuration(session: ParkingSession): string {
    const start = new Date(session.startTime);
    const end = session.endTime ? new Date(session.endTime) : new Date();
    const diff = end.getTime() - start.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hours > 0 ? `${hours}год ${mins}хв` : `${mins}хв`;
  }

  stopSession(session: ParkingSession): void {
    if (confirm('Завершити сесію паркування?')) {
      if (session._id) {
        this.apiService.stopSession(session._id).subscribe({
          next: () => {
            this.loadActiveSessions();
          },
          error: (err) => console.error('Error stopping session:', err)
        });
      }
    }
  }

  onTabChange(index: number): void {
    if (index === 1 && this.sessionHistory.length === 0) {
      this.loadHistory();
    }
  }
}
